import script from "./listBatches.vue?vue&type=script&setup=true&lang=js"
export * from "./listBatches.vue?vue&type=script&setup=true&lang=js"

import "./listBatches.vue?vue&type=style&index=0&id=0ff5b31b&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ff5b31b"]])

export default __exports__